/**
 * 全局拦截器
 */
export default class InterceptorManage{
    constructor(){
        this.handle=[];
    }
    // 添加拦截器
    use(resolve,reject=err=>Promise.reject(err)){
        this.handle.push({resolve,reject});
    }
    each(fn){
        this.handle.forEach(e=>{
            fn(e)
        });
    }
}